import { Package, Calendar } from 'lucide-react'
import { formatCurrency } from '@/utils/format-currency'
import type { PortalData } from '@/types/portalCliente'

export function PortalClienteDealSection({ data }: { data: PortalData }) {
  return (
    <section className="rounded-xl border border-white/[0.06] bg-white/[0.02] p-5 space-y-4">
      <h2 className="text-xs font-bold text-accent uppercase tracking-wider flex items-center gap-2">
        <Package size={14} />
        Projeto Ativo
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <div>
          <p className="text-[10px] text-white/40 uppercase tracking-wider mb-1">Projeto</p>
          <p className="text-sm font-medium text-white">{data.deal.nome}</p>
        </div>
        <div>
          <p className="text-[10px] text-white/40 uppercase tracking-wider mb-1">Serviço</p>
          <p className="text-sm font-medium text-white">{data.deal.servico ?? '—'}</p>
        </div>
        <div>
          <p className="text-[10px] text-white/40 uppercase tracking-wider mb-1">Valor</p>
          <p className="text-sm font-bold text-emerald-400">
            {data.deal.valor ? formatCurrency(Number(data.deal.valor)) : '—'}
          </p>
        </div>
        <div>
          <p className="text-[10px] text-white/40 uppercase tracking-wider mb-1">Recorrência</p>
          <p className="text-sm font-medium text-white">{data.deal.recorrencia ?? '—'}</p>
        </div>
      </div>

      {(data.deal.valorMensal || data.deal.valorSetup) && (
        <div className="grid grid-cols-2 gap-4 pt-3 border-t border-white/[0.06]">
          {data.deal.valorMensal && (
            <div>
              <p className="text-[10px] text-white/40 uppercase tracking-wider mb-1">Valor Mensal</p>
              <p className="text-sm font-medium text-white">{formatCurrency(Number(data.deal.valorMensal))}</p>
            </div>
          )}
          {data.deal.valorSetup && (
            <div>
              <p className="text-[10px] text-white/40 uppercase tracking-wider mb-1">Setup</p>
              <p className="text-sm font-medium text-white">{formatCurrency(Number(data.deal.valorSetup))}</p>
            </div>
          )}
        </div>
      )}

      <div className="grid grid-cols-2 gap-4 pt-3 border-t border-white/[0.06]">
        <div>
          <p className="text-[10px] text-white/40 uppercase tracking-wider mb-1">Fechamento</p>
          <p className="text-sm text-white/70 flex items-center gap-1.5">
            <Calendar size={12} className="text-accent" />
            {data.deal.dataFechamento
              ? new Date(data.deal.dataFechamento).toLocaleDateString('pt-BR')
              : '—'}
          </p>
        </div>
        <div>
          <p className="text-[10px] text-white/40 uppercase tracking-wider mb-1">Responsável</p>
          <p className="text-sm text-white/70">{data.closer.name}</p>
        </div>
      </div>
    </section>
  )
}
